<script>
import HorizontalStackedBarChart from "@/shared/charts/horizontal-stacked-bar-chart/horizontal-stacked-bar-chart.vue";
import EmployeeBySex from "@/components/modules/new-dashboard/components/employees-by-sex/employee-by-sex.vue";
import DashboardTotal from "@/components/modules/new-dashboard/components/dashboard-total.vue";
import DashboardSpinner from "@/components/modules/new-dashboard/components/dashboard-spinner.vue";
import DashboardNoData from "@/components/modules/new-dashboard/components/dashboard-no-data.vue";

export default {
  components: {DashboardNoData, DashboardSpinner, DashboardTotal, EmployeeBySex, HorizontalStackedBarChart },
  props: {
    surveyData: { type: Object, required: true },
  },
  data: function () {
    return {
      byAge: [],
      colors: {
        optionList_opinionSurvey_basicInformation_qB_age_under18: "#FCA71C",
        optionList_opinionSurvey_basicInformation_qB_age_between18And30:
          "#F32474",
        optionList_opinionSurvey_basicInformation_qB_age_between31And60:
          "#B7C51C",
        optionList_opinionSurvey_basicInformation_qB_age_older60: "#22C2E5",
      },
      colorsRight: {
        dashboard_optionList_opinionSurvey_basicInformation_qD_identifyYourself_hispanic:
          "#F32474",
        dashboard_optionList_opinionSurvey_basicInformation_qD_identifyYourself_noneOfTheAbove:
          "#B7C51C",
        dashboard_optionList_opinionSurvey_basicInformation_qD_identifyYourself_afrodescendant:
          "#22C2E5",
        dashboard_optionList_opinionSurvey_basicInformation_qD_identifyYourself_other:
          "#FCA71C",
        dashboard_optionList_opinionSurvey_basicInformation_qD_identifyYourself_indigenous:
          "#CE51BF",
      },
      ageGroups: [
        "optionList_opinionSurvey_basicInformation_qB_age_under18",
        "optionList_opinionSurvey_basicInformation_qB_age_between18And30",
        "optionList_opinionSurvey_basicInformation_qB_age_between31And60",
        "optionList_opinionSurvey_basicInformation_qB_age_older60",
      ],
      byEthnicity: [],
      bySex: {},
      ethnicityGroups: [
        "dashboard_optionList_opinionSurvey_basicInformation_qD_identifyYourself_hispanic",
        "dashboard_optionList_opinionSurvey_basicInformation_qD_identifyYourself_noneOfTheAbove",
        "dashboard_optionList_opinionSurvey_basicInformation_qD_identifyYourself_afrodescendant",
        "dashboard_optionList_opinionSurvey_basicInformation_qD_identifyYourself_other",
        "dashboard_optionList_opinionSurvey_basicInformation_qD_identifyYourself_indigenous",
      ],
      configLeft: {
        width: 300,
        height: 157,
        marginTop: 0,
        marginBottom: 0,
        axisLabelSpacePercentage: 25,
      },
      configRight: {
        width: 800,
        height: 187,
        marginTop: 0,
        marginBottom: 0,
        axisLabelSpacePercentage: 25,
      },
    };
  },
  watch: {
    surveyData: {
 handler:     function() {
        this.refresh();
      },
      deep: true,
    }
  },
  mounted() {
    this.refresh();
  },
  methods: {
    refresh: function () {
      this.formatSurveysByAge();
      this.formatSurveysByEthnicity();
      this.formatSurveysBySex();
    },
    hasData: function () {
      return this.byAge.length > 0;
    },
    formatSurveysByAge: function () {
      this.byAge = this.surveyData.data.age.map((employees) => {
        return {
          group: employees._id,
          subGroup: employees._id,
          value: employees.count,
        };
      });
    },
    formatSurveysByEthnicity: function () {
      this.byEthnicity = this.surveyData.data.ethnicity.map((employees) => {
        return {
          group: employees._id,
          subGroup: employees._id,
          value: employees.count,
        };
      });
    },
    formatSurveysBySex: function () {
      var man = this.surveyData.data.sex.find(
        (sex) =>
          sex._id === "optionList_opinionSurvey_basicInformation_qA_sex_male"
      );
      var woman = this.surveyData.data.sex.find(
        (sex) =>
          sex._id === "optionList_opinionSurvey_basicInformation_qA_sex_female"
      );
      var total = man.count + woman.count;

      this.bySex["man"] = {
        total: man.count,
        percentage: this.formatPercentage(
          100 * (total > 0 ? man.count / total : 0)
        ),
      };
      this.bySex["woman"] = {
        total: woman.count,
        percentage: this.formatPercentage(
          100 *( total > 0 ? woman.count / total : 0)
        ),
      };
    },
    formatPercentage: function (percentage) {
      return +percentage.toFixed(0) + "%";
    },
    /* hasData:function (){
/!*      var sentData = store.surveys[props.survey].sent.reduce((prev, response: Sent) => {
        return prev + +response.sent;
      },0);

      var recData = store.surveys[props.survey].responses.reduce((prev, response) => {
        return prev + +response.total;
      },0);*!/
      return false; ( sentData + recData) > 0;
    },
     getSurveysSent : function () {
      return store.surveys[props.survey].sent.map((response: Sent) => {
        return {
          group: response.step,
          subGroup: response.step,
          value: +response.sent,
        };
      });
    },
    getTotalSent: function () {
      return store.surveys[props.survey].sent.reduce(
        (total, response) => total + +response.sent,
        0,
      );
    },
    getResponses:function () {
      return store.surveys[props.survey].responses.map(
        (response: SurveyResponse) => {
          return {
            group: response.label,
            subGroup: response.step,
            value: +response.total,
            color: colorsRight[`${response.step}_${response.original}`],
          };
        },
      );
    },
 getTotalResponses: function () {
      return store.surveys[props.survey].responses.reduce(
        (acc, response) => acc + +response.total,
        0,
      );
    },
 getResponsesPercentage:function () {
      return (
        (getTotalSent() != 0
          ? ((100 * getTotalResponses()) / getTotalSent()).toFixed(0)
          : 0) + "%"
      );
    }*/
  },
};
</script>

<template>
  <div>
    <dashboard-spinner v-if="surveyData.loading"></dashboard-spinner>

    <dashboard-no-data v-if="!hasData() && !surveyData.loading">

    </dashboard-no-data>
    <div v-if="hasData() && !surveyData.loading" style="cursor: pointer">
      <div class="survey-container">
        <div class="survey-left">
          <horizontal-stacked-bar-chart
            :chart-data="byAge"
            :colors="colors"
            :config="configLeft"
            :parent-height="false"
            :custom-group-sorting="ageGroups"
          />
          <div class="details-container">
            <!--        <div class="survey-title">
          {{ $t("label_dashboard_survey_surveys_sent") }}
        </div>-->
            <!--        <div class="survey-total">{{ formatCompact(getTotalSent()) }}</div>
        <div class="survey-percentage">(100%)</div>-->
          </div>
        </div>

        <employee-by-sex
          :percentage="bySex.woman.percentage"
          :total="bySex.woman.total"
          sex="women"
        />
        <div class="survey-divider" />
        <employee-by-sex
          :percentage="bySex.man.percentage"
          :total="bySex.man.total"
          sex="men"
        />
        <div v-if="!surveyData.loading"
class="survey-right">
          <div class="details-container">
            <!--        <div class="survey-title">
          {{ $t("label_dashboard_survey_responses_received") }}
        </div>-->
            <!--        <div class="survey-total">
          {{ formatCompact(getTotalResponses()) }}
        </div>
        <div class="survey-percentage">({{ getResponsesPercentage() }})</div>-->
          </div>
          <horizontal-stacked-bar-chart
            :chart-data="byEthnicity"
            :colors="colorsRight"
            :config="configRight"
            :parent-height="false"
            :custom-group-sorting="ethnicityGroups"
            :right-to-left="true"
          />
        </div>
      </div>
      <div class="employees-surveyed">
        <div>{{$t('label_dashboard_by_age')}}</div>
        <div style="text-align: center">{{$t('label_dashboard_employees_surveyed')}}</div>
        <div style="text-align: end">{{$t('label_dashboard_by_ethnicity')}}</div>
      </div>
      <div>
        <dashboard-total :total-organizations="bySex.man.total + bySex.woman.total" :fomat="false"></dashboard-total>
      </div>
    </div>
  </div>
</template>

<style scoped>
.employees-surveyed {
  display: flex;
  justify-content: space-between;
  padding: 0 10%;
    font-size: 20px;
    color:#273A76;
    font-family: Montserrat, sans-serif;
  > div {
    flex: 1
  }

}
.details-container {
  flex-basis: 32px;
}

.survey-divider {
  height: 135px;
  background-color: #ebece4;
  width: 2px;
}

.survey-container {
  display: flex;
  gap: 23px;
}

.survey-right,
.survey-left {
  display: flex;
  align-items: center;
  text-align: right;
  flex-grow: 1;
  flex-shrink: 0;
  flex-basis: 0;
  gap: 10px;
}

.survey-title {
  font-weight: bold;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  color: #0a0a0a;
}

.survey-total {
  font-weight: bold;
  font-size: 16px;
  font-family: Montserrat, sans-serif;
  color: #2f60a6;
}

.survey-percentage {
  font-size: 16px;
  font-family: Montserrat, sans-serif;

  color: #2f60a6;
}

.loading {
  height: 135px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.other-surveys {
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  font-family: Montserrat, sans-serif;
  text-align: center;
  padding-top: 15px;
  color: #716c6e;

  .other-surveys-number {
    color: #20356e;
    font-weight: bold;
  }
}
</style>

<style lang="scss">
.survey-modal-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: center;
  .survey-container {
    flex-grow: 1;
    flex-shrink: 0;
    max-height: 250px;
  }
  .survey-divider {
    height: 100% !important;
  }
  .other-surveys {
    padding-top: 50px;
    flex-grow: 0;
    flex-shrink: 0;
    font-size: 1.5vw !important;
  }
  .details-container {
    .survey-title,
    .survey-total {
      font-size: 1.35vw !important;
    }
    .survey-percentage {
      font-size: 1.2vw !important;
    }
  }
}
</style>
